import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Link } from "react-router-dom";
import axios from "axios";

import FooterCopyright from "../../components/footer/FooterCopyright";
import FooterNewsletter from "../../components/footer/FooterNewsletter";

const Footer = ({
  backgroundColorClass,
  spaceTopClass,
  spaceBottomClass,
  spaceLeftClass,
  spaceRightClass,
  containerClass,
  extraFooterClass,
  sideMenu
}) => {
  const [siteInfo, setSiteInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSiteInfo = async () => {
      try {
        const { data } = await axios.get(
          "https://backend.elveescrubs.com/688787d8ff144c502c7f5cffaafe2cc588d86079f9de88304c26b0cb99ce91c6/api/page/site-info/"
        );
        setSiteInfo(data);
      } catch (err) {
        console.error("Error loading site info:", err);
        setError("Failed to load site info");
      } finally {
        setLoading(false);
      }
    };
    fetchSiteInfo();
  }, []);

  if (loading) {
    return (
      <footer className="footer-area text-center py-5 text-muted">
        Loading site information...
      </footer>
    );
  }

  if (error) {
    return (
      <footer className="footer-area text-center py-5 text-danger">
        {error}
      </footer>
    );
  }

  return (
    <footer
      className={clsx(
        "footer-area",
        backgroundColorClass,
        spaceTopClass,
        spaceBottomClass,
        extraFooterClass,
        spaceLeftClass,
        spaceRightClass
      )}
    >
      <div className={containerClass ? containerClass : "container"}>
        <div className="row">

          <div className={sideMenu ? "col-xl-2 col-sm-4" : "col-lg-2 col-sm-4"}>
            <FooterCopyright
              footerLogo={siteInfo?.logo}
              footerText={siteInfo?.footer_text}
              copyrightText={siteInfo?.copyright_text}
              siteName={siteInfo?.site_name}
              spaceBottomClass="mb-30"
            />
          </div>

          <div className={sideMenu ? "col-xl-2 col-sm-4" : "col-lg-2 col-sm-4"}>
            <div className="footer-widget mb-30 ml-30">
              <div className="footer-title"><h3>ABOUT</h3></div>
              <div className="footer-list">
                <ul>
                  <li><Link to={process.env.PUBLIC_URL + "/about"}>About us</Link></li>
                  <li><Link to={process.env.PUBLIC_URL + "/contact"}>Contact</Link></li>
                </ul>
              </div>
            </div>
          </div>

          <div className={sideMenu ? "col-xl-2 col-sm-4" : "col-lg-2 col-sm-4"}>
            <div className={sideMenu ? "footer-widget mb-30 ml-95" : "footer-widget mb-30 ml-50"}>
              <div className="footer-title"><h3>USEFUL LINKS</h3></div>
              <div className="footer-list">
                <ul>
                  <li><Link to={process.env.PUBLIC_URL + "/privacy-policy"}>Privacy Policy</Link></li>
                  <li><Link to={process.env.PUBLIC_URL + "/terms"}>Site Terms</Link></li>
                  <li><Link to={process.env.PUBLIC_URL + "/returns"}>Returns</Link></li>
                </ul>
              </div>
            </div>
          </div>

          <div className={sideMenu ? "col-xl-3 col-sm-4" : "col-lg-2 col-sm-6"}>
            <div className={sideMenu ? "footer-widget mb-30 ml-145" : "footer-widget mb-30 ml-75"}>
              <div className="footer-title"><h3>FOLLOW US</h3></div>
              <div className="footer-list">
                <ul>
                  {siteInfo?.social_links
                    ?.filter(link => link.is_active)
                    ?.map((link, index) => (
                      <li key={index}>
                        <a
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {link.name}
                        </a>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>

          <div className={sideMenu ? "col-xl-3 col-sm-8" : "col-lg-4 col-sm-6"}>
            <FooterNewsletter
              spaceBottomClass="mb-30"
              spaceLeftClass="ml-70"
              sideMenu={sideMenu}
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  backgroundColorClass: PropTypes.string,
  containerClass: PropTypes.string,
  extraFooterClass: PropTypes.string,
  sideMenu: PropTypes.bool,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
  spaceLeftClass: PropTypes.string,
  spaceRightClass: PropTypes.string
};

export default Footer;
